<template>
  <div class="reports">
    <header>
      <div class="left">
        <h2>Reports</h2>
        <p>Gain insight</p>
      </div>

      <!-- <div class="right">
        <a class="main-action">Export report</a>
      </div> -->
    </header>

    <div class="d-flex justify-content-end">
      <a class="outline-button" v-b-toggle.sidebar-reports-filters>
        <img src="~@/assets/icons/filters.svg"/>
        Filters{{ filterCount > 0 ? ` (${filterCount})` : '' }}
      </a>

      <toggle-button
        v-if="app_user.role !== 'User'"
        label="Only my team"
        :value="filtered_by_my_cat"
        :onChange="toggleMyCategory"
      />

      <toggle-button
        v-if="app_user.role === 'User'"
        label="Only my projects"
        :value="filtered_by_my_user"
        :onChange="toggleMyProjects"
      />

      <div class="outline-button fy-button">
        <i class="material-icons chevron" @click="yearEnding -= 1"
        >chevron_left</i
        >
        <span>{{ getFYMonth(yearEnding) }}</span>
        <i class="material-icons chevron" @click="yearEnding += 1"
        >chevron_right</i
        >
      </div>
    </div>

    <div class="main">
      <div class="panel">
        <keep-alive>
          <div v-if="loading.spend_summary" class="text-center">
            <b-spinner
              label="Loading..."
              variant="primary"
              style="width: 3rem; height: 3rem;"
              type="grow"
            ></b-spinner>
          </div>
          <SpendSummary
            v-else-if="spend_summary"
            :spendSummary="spend_summary"
            :year-ending="yearEnding"
          />
        </keep-alive>
      </div>

      <div class="panel">
        <div v-if="loading.top_projects_by_savings" class="loader">
          <b-spinner
            label="Loading..."
            variant="primary"
            style="width: 3rem; height: 3rem;"
            type="grow"
          ></b-spinner>
        </div>
        <TopProjectsBySavings
          v-else-if="top_projects_by_savings"
          :topProjects="top_projects_by_savings"
          :currencyFormatter="currencyFormatter"
        />
      </div>

      <div class="panel">
        <div v-if="loading.savings_report" class="loader">
          <b-spinner
            label="Loading..."
            variant="primary"
            style="width: 3rem; height: 3rem;"
            type="grow"
          ></b-spinner>
        </div>
        <div v-else-if="savings_report">
          <div class="savings-actions">
            <div>
              <b-form-radio-group
                v-model="savingsReportView.selected"
                :options="savingsReportView.options"
                name="savings-report-view-selector"
                buttons
                button-variant="outline-primary"
                size="sm"
              ></b-form-radio-group>
            </div>
          </div>
          <SavingsReport
            :savingsReport="savings_report"
            :yearEnding="yearEnding"
            :view="savingsReportView.selected"
          />
        </div>
      </div>

      <div class="panel">
        <div v-if="loading.benefits_by_savings_type" class="loader">
          <b-spinner
            label="Loading..."
            variant="primary"
            style="width: 3rem; height: 3rem;"
            type="grow"
          ></b-spinner>
        </div>
        <SavingsBySavingsType
          v-else-if="benefits_by_savings_type"
          :benefits="benefits_by_savings_type"
          :currencyFormatter="currencyFormatter"
        />
      </div>

      <div class="charts">
        <div v-if="false" class="panel left">
          <div v-if="loading.projects_stats" class="loader">
            <b-spinner
              label="Loading..."
              variant="primary"
              style="width: 3rem; height: 3rem;"
              type="grow"
            ></b-spinner>
          </div>
          <bar-chart
            v-else-if="projects_stats"
            title="Top Projects By Spend"
            :datasets="top_projects_by_spend"
            :options="projects_by_spend_options"
            style="height: 300px"
          />
        </div>

        <div class="panel left">
          <div v-if="loading.projects_stats" class="loader">
            <b-spinner
              label="Loading..."
              variant="primary"
              style="width: 3rem; height: 3rem;"
              type="grow"
            ></b-spinner>
          </div>
          <line-chart
            v-else-if="projects_stats"
            title="New Projects By Month"
            :data="project_inits"
            :labels="months"
            style="height: 300px"
          />
        </div>

        <div class="panel right">
          <div v-if="loading.top_stakeholders" class="loader">
            <b-spinner
              label="Loading..."
              variant="primary"
              style="width: 3rem; height: 3rem;"
              type="grow"
            ></b-spinner>
          </div>
          <TopStakeholders
            v-else-if="top_stakeholders"
            :stakeholders="top_stakeholders"
          />
        </div>
      </div>



      <div class="panel">
        <div v-if="loading.project_qtys" class="loader">
          <b-spinner
            label="Loading..."
            variant="primary"
            style="width: 3rem; height: 3rem;"
            type="grow"
          ></b-spinner>
        </div>
        <ProjectQtys v-else :data="project_qtys"/>
      </div>

      <div class="charts">
        <div class="panel left">
          <div v-if="loading.overdue_pipeline_projects" class="loader">
            <b-spinner
              label="Loading..."
              variant="primary"
              style="width: 3rem; height: 3rem;"
              type="grow"
            ></b-spinner>
          </div>
          <OverduePipelineProjects
            v-else-if="overdue_pipeline_projects"
            :overdueProjects="overdue_pipeline_projects"
          />
        </div>

        <div class="panel left">
          <div v-if="loading.overdue_unrealised_benefits" class="loader">
            <b-spinner
              label="Loading..."
              variant="primary"
              style="width: 3rem; height: 3rem;"
              type="grow"
            ></b-spinner>
          </div>
          <OverdueUnrealisedBenefits
            v-else-if="overdue_unrealised_benefits"
            :overdueBenefits="overdue_unrealised_benefits"
          />
        </div>
      </div>
    </div>

    <b-sidebar id="sidebar-reports-filters" title="Filters" right shadow lazy>
      <div class="filters">
        <!-- <div v-if="['Admin', 'SuperAdmin'].includes(app_user_role)">
          <label>Team</label>
          <multi-select
            type="teamMembers"
            :values="filters.teamMembers"
            :onChange="handleChange"
            label="team member"
            labelPlural="team members"
            includeSearch
          />
        </div>
        <div v-else>
          <toggle-button
            class="toggle"
            label="Only my projects"
            :value="filtered_by_my_user"
            :onChange="toggleMyProjects"
          />
        </div> -->

        <label>Stakeholders</label>
        <multi-select
          type="teamMembers"
          :values="filters.teamMembers"
          :onChange="handleChange"
          label="stakeholder"
          labelPlural="stakeholders"
          includeSearch
        />

        <label>Statuses</label>
        <multi-select
          type="status"
          :values="filters.status"
          :onChange="handleChange"
          label="status"
          labelPlural="statuses"
          :optionFilters="['On hold', 'Cancelled']"
        />

        <label>Types</label>
        <multi-select
          type="type"
          :values="filters.type"
          :onChange="handleChange"
          label="type"
          labelPlural="types"
        />

        <label>Team</label>
        <multi-select
          type="categoryId"
          :values="filters.categoryId"
          :onChange="handleChange"
          label="team"
          labelPlural="teams"
        />

        <div class="apply-filters">
          <b-button
            class="mt-3"
            :disabled="false"
            variant="outline-primary"
            block
            @click="setNewFilters()"
          >Apply
          </b-button
          >
        </div>
      </div>
    </b-sidebar>
  </div>
</template>

<script>
import SpendSummary from '../components/reports/spend_summary';
import ProjectQtys from '../components/reports/project_qtys';
import currency from '../utils/currency';
import LineChart from '../components/charts/LineChart';
import BarChart from '../components/charts/BarChart';
import API from '../api/index';
import {mapGetters} from 'vuex';
import MultiSelect from '../components/MultiSelect';
import ToggleButton from '../components/ToggleButton.vue';
import SavingsReport from '../components/reports/savings_report.vue';
import fy_months from '../utils/fy_months';
import moment from 'moment';
import TopProjectsBySavings from "@/components/reports/TopProjectsBySavings";
import TopStakeholders from "@/components/reports/TopStakeholders";
import OverduePipelineProjects from "@/components/reports/overdue_pipeline_Projects";
import OverdueUnrealisedBenefits from "@/components/reports/overdue_unrealised_benefits";
import SavingsBySavingsType from "@/components/reports/SavingsBySavingsType";

export default {
  name: 'Reports',
  components: {
    OverduePipelineProjects,
    OverdueUnrealisedBenefits,
    TopProjectsBySavings,
    TopStakeholders,
    ProjectQtys,
    LineChart,
    BarChart,
    SpendSummary,
    'multi-select': MultiSelect,
    'toggle-button': ToggleButton,
    SavingsReport,
    SavingsBySavingsType
  },
  data: () => ({
    spend_summary: null,
    savings_report: null,
    savingsReportView: {
      selected: 'realized',
      options: [
        {text: 'Realised', value: 'realized'},
        {text: 'Forecasted', value: 'forecasted'},
      ]
    },
    projects_stats: null,
    top_projects_by_savings: null,
    project_qtys: null,
    top_stakeholders: null,
    overdue_pipeline_projects: null,
    overdue_unrealised_benefits: null,
    benefits_by_savings_type: null,
    loading: {
      spend_summary: false,
      savings_report: false,
      projects_stats: false,
      project_qtys: false,
      top_projects_by_savings: false,
      top_stakeholders: false,
      overdue_pipeline_projects: false,
      overdue_unrealised_benefits: false,
      benefits_by_savings_type: false
    },
    yearEnding: new Date().getFullYear(),
    months: [
      'January',
      'February',
      'March',
      'April',
      'May',
      'June',
      'July',
      'August',
      'September',
      'October',
      'November',
      'December',
    ],
    filters: {
      teamMembers: ['All'],
      status: ['All'],
      categoryId: ['All'],
      type: ['All'],
    },
  }),
  mounted() {
    // Check in which financial year we are now
    const fyObject = fy_months(
      this.$store.getters.org.fy_month,
      this.yearEnding
    );
    if (
      moment(`${fyObject.prev_month} ${this.yearEnding}`, 'MMM YYYY').endOf('month').isSameOrBefore(
        new Date()
      )

    )
      this.yearEnding++;

    // Get filters from previous session from local storage
    this.filters = {...this.filters, ...JSON.parse(localStorage.getItem('reports_filters'))};

    this.getAllReports();
  },
  watch: {
    yearEnding(newVal, oldVal) {
      if (newVal !== oldVal) this.getAllReports();
    },
  },
  computed: {
    ...mapGetters(['currencyCodeById', 'rootCategory']),
    app_user() {
      return this.$store.getters.app_user || {};
    },
    app_user_role() {
      return this.app_user ? this.app_user.role : '';
    },
    filtered_by_my_user() {
      const user_filters = this.filters.teamMembers;
      if (!user_filters) return false;

      return user_filters.length === 1 && user_filters[0] === this.app_user.id;
    },
    filtered_by_my_cat() {
      const cat_filters = this.filters.categoryId;
      if (!cat_filters) return false;

      const { categoryId, relatedCategories } = this.app_user;

      // create a set containing all the category ids for the user, if relatedCategories is defined
      const userCategoryIds = new Set([...(relatedCategories.map(el => el.id) || []), categoryId]);

      // fetch the category objects for each user category id
      const userCategories = Array.from(userCategoryIds).map(id => this.rootCategory[id]);

      // create a set containing all the filtered ids
      const filteredIdsSet = new Set(cat_filters);

      // fetch the category objects for each filtered id
      const filteredCategories = cat_filters.map(id => this.rootCategory[id]);

      // check if the sets are equal (i.e., if filteredIds contains only the user's category ids)
      return (filteredIdsSet.size === userCategoryIds.size) &&
        userCategories.every(category => filteredCategories.includes(category));
    },
    filterCount() {
      let filterCount = 0;
      filterCount += Object.keys(this.filters)
        .map(key => this.filters[key].includes('All'))
        .filter(e => e === false).length;
      return filterCount;
    },
    project_inits() {
      const format = rawData => {
        let datasetLabels = [];
        rawData.forEach(yearMonth => datasetLabels.push(yearMonth.year));
        const formatted = datasetLabels
          .sort()
          .filter((item, pos, ary) => !pos || item !== ary[pos - 1])
          .map(label => {
            let filtered = rawData.filter(obj => obj.year === label);

            return {
              label,
              data: filtered.map(obj => ({
                label: this.months[obj.month - 1],
                value: obj.count,
              })),
            };
          });

        return formatted;
      };
      return !this.projects_stats
        ? null
        : format(this.projects_stats.project_inits);
    },
    top_projects_by_spend() {
      const format = rawData => {
        return [
          {
            label: '',
            data: rawData.map(e => {
              return {
                label: e.shortId,
                value: e.estAnnualSpend,
              };
            }),
          },
        ];
      };
      return !this.projects_stats
        ? null
        : format(this.projects_stats.top_projects_by_spend);
    },
    currencyFormatter() {
      const currCode = this.app_user
        ? this.currencyCodeById(this.app_user.organization.currencyId)
        : '';
      return (value) => {
        currency.locale(currCode);
        return currency(value).format('$0a.[0]');
      }
    },
    projects_by_spend_options() {
      const currCode = this.app_user
        ? this.currencyCodeById(this.app_user.organization.currencyId)
        : '';
      return {
        scales: {
          xAxes: [
            {
              ticks: {
                // Include a currency sign in the ticks
                callback: function (value) {
                  currency.locale(currCode);
                  return currency(value).format('$0a.[0]');
                },
              },
            },
          ],
        },
        tooltips: {
          callbacks: {
            label: tooltipItem => {
              currency.locale(currCode);
              return currency(tooltipItem.value).format('$0a.[0]');
            },
          },
        },
      };
    },
  },
  methods: {
    getAllReports() {
      const filters = this.filters;
      this.getSpendSummary(filters);
      this.getSavingsReport(filters);
      this.getProjectsStats(filters);
      this.getTopProjectsBySavings(filters);
      this.getProjectQtys(filters);
      this.getTopStakeholders(filters);
      this.getOverduePipelineProjects(filters);
      this.getOverdueUnrealisedBenefits(filters);
      this.getBenefitsBySavingsType(filters);
    },
    handleChange(val, kind) {
      if (val === 'All') {
        this.filters[kind] = ['All'];
        return;
      }

      // they've picked something other than All, so filter All out
      this.filters[kind] = this.filters[kind].filter(s => s !== 'All');

      // if they've picked something we already have, deselect it
      if (this.filters[kind].includes(val)) {
        this.filters[kind] = this.filters[kind].filter(s => s !== val);

        if (!this.filters[kind].length) {
          this.filters[kind] = ['All'];
        }

        return;
      }

      this.filters[kind].push(val);
    },
    applyFilters() {
      // Save filter selection to LocalStorage for future sessions
      localStorage.setItem('reports_filters', JSON.stringify(this.filters));

      this.getAllReports();
    },
    toggleMyProjects(bool) {
      this.filters.teamMembers = bool ? [this.app_user.id] : ['All'];
      this.applyFilters();
    },
    toggleMyCategory(bool) {
      const getRootCategories = () => {
        let filteredIds = [];

        // add the categoryId to the filteredIds array
        filteredIds.push(this.app_user.categoryId);

        // if relatedCategories is defined, add its values to the filteredIds array
        if (this.app_user.relatedCategories) {
          filteredIds = filteredIds.concat(this.app_user.relatedCategories.map(el => el.id));
        }

        // remove any duplicate values from the filteredIds array
        filteredIds = [...new Set(filteredIds)];

        // map each id to its corresponding category object
        return filteredIds.map(id => this.rootCategory[id]);
      }
      this.filters.categoryId = bool ? getRootCategories() : ['All'];
      this.applyFilters();
    },
    setNewFilters(){
      this.$root.$emit('bv::toggle::collapse', 'sidebar-reports-filters');
      this.applyFilters();
    },
    getFilterparams(filters) {
      const params = [];
      Object.keys(filters).forEach(key => {
        let value = filters[key];

        if (Array.isArray(value)) {
          if(key === 'status' && value.length === 1 && value[0] === 'All') {
            params.push({key, value: ['Active', 'Completed', 'Pipeline']});
            return;
          }
          value = value.filter(v => v !== 'All');
        }

        if ((value && value.length) || value > 0) {
          params.push({key, value});
        }
      });

      // Add yearEnding filter
      if (this.yearEnding) {
        params.push({key: "yearEnding", value: this.yearEnding})
      }

      return params;
    },
    getFYMonth(yearEnding) {
      return fy_months(this.$store.getters.org.fy_month, yearEnding).year;
    },
    async getSpendSummary(filters) {
      try {
        this.loading.spend_summary = true;
        const {data} = await API.getSpendSummary(
          filters && this.getFilterparams(filters)
        );
        this.spend_summary = data.spendSummary;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading.spend_summary = false;
      }
    },
    async getSavingsReport(filters) {
      try {
        this.loading.savings_report = true;

        const params = this.getFilterparams({
          ...filters,
          yearEnding: this.yearEnding,
        });
        const {data} = await API.getSavingsReport(params);
        this.savings_report = data.savingsReport;
      } catch (error) {
        console.error(error);
      } finally {
        this.$nextTick(() => {
          this.loading.savings_report = false;
        });
      }
    },
    async getProjectsStats(filters) {
      try {
        this.loading.projects_stats = true;
        const {data} = await API.getProjectStats(
          filters && this.getFilterparams(filters)
        );
        this.projects_stats = data.projectsStats;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading.projects_stats = false;
      }
    },
    async getTopProjectsBySavings(filters) {
      try {
        this.loading.top_projects_by_savings = true;
        const {data} = await API.getTopProjectsBySavings(
          filters && this.getFilterparams(filters)
        );
        this.top_projects_by_savings = data.topProjectsBySavings;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading.top_projects_by_savings = false;
      }
    },
    async getProjectQtys(filters) {
      try {
        this.loading.project_qtys = true;
        const {data} = await API.getProjectQtys(
          filters && this.getFilterparams(filters)
        );
        this.project_qtys = data.projectQtys;
      } catch (error) {
        console.error(error);
      } finally {
        this.loading.project_qtys = false;
      }
    },
    async getTopStakeholders(filters) {
      try {
        this.loading.top_stakeholders = true;
        const {data} = await API.getTopStakeholders(
          filters && this.getFilterparams(filters)
        );
        this.top_stakeholders = data.topStakeholders;
      }
      catch (error) {
        console.error(error);
      }
      finally {
        this.loading.top_stakeholders = false;
      }
    },
    async getOverduePipelineProjects(filters) {
      try {
        this.loading.overdue_pipeline_projects = true;
        const {data} = await API.getOverduePipelineProjects(
          filters && this.getFilterparams(filters)
        );
        this.overdue_pipeline_projects = data.overduePipelineProjects;
      }
      catch (error) {
        console.error(error);
      }
      finally {
        this.loading.overdue_pipeline_projects = false;
      }
    },
    async getOverdueUnrealisedBenefits(filters) {
      try {
        this.loading.overdue_unrealised_benefits = true;
        const {data} = await API.getOverdueUnrealisedBenefits(
          filters && this.getFilterparams(filters)
        );
        this.overdue_unrealised_benefits = data.overdueUnrealisedProjects;
      }
      catch (error) {
        console.error(error);
      }
      finally {
        this.loading.overdue_unrealised_benefits = false;
      }
    },
    async getBenefitsBySavingsType(filters) {
      try {
        this.loading.benefits_by_savings_type = true;
        const {data} = await API.getBenefitsBySavingsType(
          filters && this.getFilterparams(filters)
        );
        if(data.benefitsBySavingsType) {
          this.benefits_by_savings_type = data.benefitsBySavingsType;
        }
      }
      catch (error) {
        console.error(error);
      }
      finally {
        this.loading.benefits_by_savings_type = false;
      }
    },
    formatCurrency(num) {
      if (!this.app_user) {
        return '0';
      }
      currency.locale(
        this.currencyCodeById(this.app_user.organization.currencyId)
      );
      return currency(num).format('$0a.[0]');
    },
  },
};
</script>

<style lang="scss" scoped>
@import '../styles/_styles.scss';

.reports {
  position: relative;

  .main {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    // align-items: stretch;

    .panel {
      margin-top: 30px;
      padding: 25px;
      font-size: 14px;
      position: relative;
    }

    .left {
      width: 48%;
    }

    .right {
      width: 48%;
    }
  }
}

.filters {
  padding: 0px 20px;

  label {
    color: #26292f;
    font-size: 16px;
    font-weight: 500;
    margin-top: 40px;
    display: block;
  }
}

.charts {
  display: flex;
  flex-flow: row wrap;
  justify-content: space-between;
}

.donut {
  width: 300px;
}

.loader {
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}

.savings-actions {
  display: flex;
  justify-content: space-between;
  width: 100%;
  position: absolute;
  top: 30px;
  margin-right: -25px;
  margin-left: -25px;
  padding-right: 25px;
  padding-left: 25px;

  img {
    width: 16px;
    margin-right: 8px;
  }
}

.fy-button {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-left: 15px;
  padding-top: 0;
  padding-bottom: 0;
  cursor: auto;

  .chevron {
    cursor: pointer;
  }
}
</style>
